// Yasal metin tipleri. Admin panelinden (Portal İçerik Yönetimi > Tüm Sayfa
// Açıklamaları) bu "type" anahtarlarıyla kaydedilen metinler, buradaki
// public endpoint üzerinden çekilir. Yeni bir tip eklenirse admin tarafındaki
// connection-frontendAdmin/src/pages/PageDescriptions/index.js listesiyle
// birebir aynı olmalıdır.
export const LEGAL_TEXT_TYPES = {
  KISISEL_VERILER_BILDIRIMI: "KISISEL_VERILER_BILDIRIMI",
  AYDINLATMA_METNI: "AYDINLATMA_METNI",
  CEREZ_POLITIKASI: "CEREZ_POLITIKASI",
  TICARI_ELEKTRONIK_ILETI_IZNI: "TICARI_ELEKTRONIK_ILETI_IZNI",
};
